"use client";

import { Badge } from '@radix-ui/themes';
import { AlertCircle, CheckCircle, Clock, Loader2, Trash2, FileText } from 'lucide-react';

export type InstagramUiStatus =
  | 'draft'
  | 'scheduled'
  | 'publishing'
  | 'published'
  | 'failed'
  | 'deleted';

const config: Record<
  InstagramUiStatus,
  {
    label: string;
    color: 'gray' | 'blue' | 'green' | 'red' | 'orange' | 'yellow';
    Icon: typeof FileText;
  }
> = {
  draft: { label: 'Draft', color: 'gray', Icon: FileText },
  scheduled: { label: 'Scheduled', color: 'blue', Icon: Clock },
  publishing: { label: 'Publishing', color: 'yellow', Icon: Loader2 },
  published: { label: 'Published', color: 'green', Icon: CheckCircle },
  failed: { label: 'Failed', color: 'red', Icon: AlertCircle },
  deleted: { label: 'Deleted', color: 'orange', Icon: Trash2 },
};

export function normalizeInstagramUiStatus(status: string | null | undefined): InstagramUiStatus {
  if (
    status === 'scheduled' ||
    status === 'publishing' ||
    status === 'published' ||
    status === 'failed' ||
    status === 'deleted'
  ) {
    return status;
  }
  return 'draft';
}

export default function InstagramStatusBadge({
  status,
}: {
  status: string | null | undefined;
}) {
  const normalized = normalizeInstagramUiStatus(status);
  const { label, color, Icon } = config[normalized];
  return (
    <Badge variant="soft" color={color} className="inline-flex items-center gap-1 capitalize">
      <Icon className={`h-3 w-3 ${normalized === 'publishing' ? 'animate-spin' : ''}`} />
      {label}
    </Badge>
  );
}
